export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  name: '新品确认',
  isMenu: true,
  code: 'newProductConfirmation',
  menuType: 'C',
  url: 'newProductConfirmation',
  title: '新品确认',
} as TCommon.RouteConfig
